// removed by extract-text-webpack-plugin
module.exports = {"didYouMeanLink":"_1c_bq"};